import { styled } from "styled-components";

export const MyPageTitle = styled.div`
  font-size: 32px;
  line-height: 150px;

  width: 600px;
`;
